var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"advocacy-actionwidget",attrs:{"data-domain":"p2a.co","data-shorturl":"ftsNzE2"}})])}]

export { render, staticRenderFns }